export default __webpack_public_path__ + "static/media/english-ws-lc.5ed378b0.jpg";